import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <path
          d="M45.464 50.6L41.24 39.056C41.032 38.544 40.816 37.936 40.592 37.232C40.368 36.528 40.144 35.768 39.92 34.952C39.712 35.768 39.496 36.536 39.272 37.256C39.048 37.96 38.832 38.576 38.624 39.104L34.424 50.6H45.464ZM56.864 63.704H51.872C51.312 63.704 50.856 63.568 50.504 63.296C50.152 63.008 49.888 62.656 49.712 62.24L47.12 55.16H32.744L30.152 62.24C30.024 62.608 29.776 62.944 29.408 63.248C29.04 63.552 28.584 63.704 28.04 63.704H23L36.656 29H43.232L56.864 63.704Z"
          fill="currentColor"
        />
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
    </g>
  </svg>

);

export default IconLogo;
